import * as React from 'react'
import * as parser from 'xml-js'
import { Select, message } from 'antd'
import { BCXmlItem } from '@getgreenline/homi-shared'
import { inject, observer } from 'mobx-react'
import { parseErrorMsg } from '../../../../../../../utilities/helpers'
import { CreateInvoiceDetail } from '../../../InvoiceDetailStore'
import { OptionProps } from 'antd/lib/select'

interface IOrderNumberList {
  orderNumber: string
  purchaseOrderDate: string
}

interface Props {
  createInvoice: CreateInvoiceDetail
  originFileObj: File | Blob
}

interface State {
  orderNumberList: IOrderNumberList[]
}

@inject('currentCompanyStore', 'currentUserStore')
@observer
export class OrderList extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      orderNumberList: [],
    }
  }

  componentDidMount = async () => {
    await this.parseOrderNumbers()
  }

  parseOrderNumbers = async () => {
    const { orderNumberList } = this.state

    try {
      const text = await this.props.originFileObj.text()

      const json = parser.xml2js(text, { compact: true })

      let headerSection =
        json[BCXmlItem.ADVANCE_SHIPMENT_NOTICE][BCXmlItem.ASN_HEADER][BCXmlItem.ASN_ORDER_NUMBER]

      // If there is only 1 order number, JS automatically converts it to an object rather than an array
      if (!Array.isArray(headerSection)) {
        headerSection = [headerSection]
      }

      for (const row of headerSection) {
        const orderNumber = row[BCXmlItem.BUYER_ORDER_NUMBER][BCXmlItem.VALUE]
        const purchaseOrderDate = row[BCXmlItem.PURCHASE_ORDER_DATE][BCXmlItem.VALUE]

        orderNumberList.push({ orderNumber, purchaseOrderDate })
      }

      this.setState({ orderNumberList })
    } catch (error) {
      message.error(parseErrorMsg(error) || 'An error occurred while parsing order numbers')
    }
  }

  render() {
    return (
      <div>
        <h5>Choose which order to import</h5>

        <Select<string | undefined>
          className='w-50'
          optionLabelProp='label'
          allowClear
          placeholder='Please select order number'
          showSearch
          filterOption={(input, option) => {
            const optionName = option.props.value

            if (optionName && typeof optionName === 'string') {
              const lowerCaseInput = input.toLowerCase().trim()

              return optionName.toLowerCase().indexOf(lowerCaseInput) >= 0
            }

            return true
          }}
          value={this.props.createInvoice.orderNumber || undefined}
          onChange={(value) => {
            this.props.createInvoice.setOrderNumber(value || null)
          }}
        >
          {this.state.orderNumberList.map((item, index) => {
            return (
              <Select.Option
                key={index}
                value={item.orderNumber}
                label={`Order: ${item.orderNumber}`}
              >
                <div>{`Order: ${item.orderNumber}`}</div>
                <div>{`Date: ${item.purchaseOrderDate.split('T')[0]}`}</div>
              </Select.Option>
            )
          })}
        </Select>
      </div>
    )
  }
}
